import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { FixedbottomButtonCover } from "../../../common";
import primaryComponents from "../../../primaryComponents";
import { ProductSelection } from "./ProductSelection";
import styles from "./styles.module.scss";
import { useBulkExpenseForm } from "./useBulkExpenseForm";
import { useValidation } from "./useValidation";

export const BulkExpenseForm = () => {
  const { isCreatingExpense, bulkForm, setBulkForm, handleCreateExpense } =
    useBulkExpenseForm();
  const { handleSubmit, ...validationParams } = useValidation({ ...bulkForm });

  return (
    <form
      className={`${globalStyles.pageColumnGaps} ${styles.purchaseOrderForm}`}
      onSubmit={handleSubmit(handleCreateExpense)}
    >
      <ProductSelection
        {...validationParams}
        handleSubmit={handleSubmit}
        bulkForm={bulkForm}
        setBulkForm={setBulkForm}
      />

      <FixedbottomButtonCover>
        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          style={{ width: "200px" }}
          type="submit"
          isDisabled={isCreatingExpense}
          isLoading={isCreatingExpense}
          loadingText={"Creating..."}
        >
          Create Expense
        </primaryComponents.Button>
      </FixedbottomButtonCover>
    </form>
  );
};
